import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
})
export class NavComponent implements OnInit, OnChanges {
  constructor(private router: Router) {}

  selectedComapy: any = {};

  ngOnChanges(changes: SimpleChanges): void {}

  @Input() companies: any;
  @Input() menuItems: any = [];
  @Input() selectedMenuItem: any;
  @Input() selectedCompany: any;
  @Output() handleMenuItemChange = new EventEmitter<string>();
  @Output() handleCompanyChange = new EventEmitter<string>();

  onMenuItemChange(item: any) {
    this.handleMenuItemChange.emit(item);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.selectedMenuItem = history.state;
      });
  }

  onCompanyChange(event: any) {
    this.handleCompanyChange.emit(event);
  }
}
